import React from 'react'
import styled from '@emotion/styled'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg'
import { mediaQueries } from '../../theme'
import { H1 } from '../../components/shared/type'
import Link from '../shared/link'

const Title = styled(H1)``

const Subtitle = styled.span`
  color: ${p => p.theme.colors.blue[0]};
  display: inline-block;
`

const Arrow = styled(ArrowIcon)`
  display: inline-block;
  transform: rotate(-90deg);
  width: 25px;
  height: 25px;
  margin: 0 15px;
  ${mediaQueries.lg} {
    width: 45px;
    height: 45px;
  }
`

const Heading = ({ subtitle, children, ...rest }) => (
  <Title {...rest}>
    {subtitle ? (
      <>
        <Link to="/templates/" variant="nav">
          {children}
        </Link>
        <Arrow />
        <Subtitle>{subtitle}</Subtitle>
      </>
    ) : (
      children
    )}
  </Title>
)

export default Heading
